<template>
  <div class="basic_wrap finance-page cash-premium">
    <div class="red_top_bg finance-header">
      <div
        class="back_left"
        @click="$router.go(-1)"
      />
      <div class="big_tit">
        {{ $t('cash.withdraw') }}
      </div>
      <div
        class="top_right"
        @click="$router.push('/cashlist')"
      >
        <van-icon
          name="bars"
          size="20"
        />
      </div>
    </div>
    <div class="balance balance-card">
      <p>
        {{ utils_moneyMark() }} {{ data.money }}
      </p>
      <p>
        {{ $t('invest.availableBalance') }}   
      </p>
    </div>
    <!-- 	<div class="balance" >
			<dl class="ratio-info">
			    <dd><span class="text-gray">{{$t('cash.abletimes')}}：</span><em>{{data.cash_maxnum}} {{$t('cash.time')}}</em></dd>
			    <dd><span class="text-gray">{{$t('cash.usdtimes')}}：</span><em>{{data.cashnum}} {{$t('cash.time')}}</em></dd>
			    <dd><span class="text-gray">{{$t('cash.isable')}}：</span><em>{{$t('cash.yes')}}</em></dd>
			    <dd><span class="text-gray">{{$t('cash.mincash')}}：</span><em>{{utils_moneyMark()}} {{data.min_cash}} </em></dd>
			</dl>
		</div> -->
    <div class="wrap_box wrap1 withdraw-card">
      <div class="withdraw_wrap amount-field">
        <p>{{ $t('cash.amount') }}</p>
        <div
          class="flex_center"
          style=""
        >
          <span>{{ utils_moneyMark() }}</span>
          <input
            v-model="form.money" 
            type="number"
            step="1"
            class="inp"
            :placeholder="$t('cash.withdrawableAmount') + utils_moneyMark()+data.money"
            @input="changeAmount"
          >
          <button
            class="allbtn"
            type="button"
            @click="cashall()"
          >
            {{ $t('item.all') }}
          </button>
					
          <!-- <span>{{actualAmount}}</span> -->
        </div>
        <p v-if="chargeTip">
          {{ chargeTip }}
        </p>
      </div>
      <div class="withdraw_wrap pin-field">
        <p>{{ $t('shopd.region') }}</p>
        <div style="display: flex;">
          <input
            v-model="form.password"
            maxlength="6"
            :placeholder="$t('d.withdrawpin')"
            max="999999"
            size="6"
            :type="newpasswordInp"
          >
          <div
            class="eye_bi"
            :class="newpasswordInp=='text'?'eye':''"
            @click="showNewsPwd"
          />
          <!-- 	 <input
					  v-model="form.password" 
					  type="number"
					  class="inp"
					  :placeholder="$t('d.withdrawpin')"
					> -->
        </div>
      </div>
      <div
        class="choose_bank"
        @click="$router.push('/addr')"
      >
        <div>
          <span>{{ $t('cash.wallet') }}</span>
        </div>
        <div>
          <span>
            <span
              v-if="accaddr"
              style="margin-right: 10px;"
            >{{ accaddr }}<br></span>
            {{ bank_name }}
          </span>
          <van-icon
            name="arrow"
            color="#999"
          />
        </div>
      </div>
      <!-- <div class="choose_bank">
				<div >
					<span >Wallet</span>
				</div>
				<div>
					<span >Add Fund Info</span>
					<i class="van-icon van-icon-arrow" style="color: rgb(153, 153, 153);">
					</i>
				</div>
			</div> -->
      <!-- <van-action-sheet
			  v-model="show"
			  :actions="actions"
			  :cancel-text="this.$t('shopd.cancelbtn')"
			  :description="this.$t('cash.chooseWallet')"
			  close-on-click-action
			  @click="doAddAddr"
			/> -->
      <p class="canal_tips">
        {{ $t('cash.arrivalTime') }}
      </p>
    </div>
    <div
      class="basic_btn"
      @click="submit()"
    >
      {{ $t('utils.submit') }}
    </div>
    <van-popup
      v-model="write_psd"
      closeable
      close-icon="close"
      round
      position="bottom"
    >
      <div class="psw_box">
        <van-password-input
          :value="psd_val"
          :mask="true"
          :focused="showKeyboard"
          @focus="showKeyboard = true"
        />
        <div class="keybord_box">
          <div class="keybord">
            <div
              v-for="i in 9"
              :key="i"
              class="key_item"
              @click="onInput(i)"
            >
              <div class="key_inner">
                {{ i }}
              </div>
            </div>
            <div class="key_item no_bg">
              <div class="key_inner" />
            </div>
            <div
              class="key_item"
              @click="onInput(0)"
            >
              <div class="key_inner">
                0
              </div>
            </div>
            <div
              class="key_item no_bg x"
              @click="onDelete"
            >
              <div class="key_inner">
                x
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
    <van-dialog
      v-model="show_tc"
      width="60%"
      :confirm-button-text="$t('utils.confirm')"
    >
      <!-- <img width="100%" src="../images/index/tanchuang.png"> -->
      <div
        class="popup"
        v-html="tc_content"
      />
    </van-dialog>
    <div
      v-show="setPwd"
      class="real_name_mask"
    >
      <div class="real_box">
        <div class="tit" />
        <p class="tips">
          {{ $t('cash.setPwdFirst') }}
        </p>
        <div
          class="basic_btn"
          @click="setIniPwd"
        >
          {{ $t('cash.setNow') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import Vue from 'vue';
    import Fetch from '../../utils/fetch'
    import {
        DropdownMenu,
        DropdownItem,
		Dialog,
		Popup,
		PasswordInput,
		NumberKeyboard,
		Icon,
		ActionSheet
    } from 'vant';
    Vue
	.use(Dialog)
	.use(PasswordInput)
	.use(NumberKeyboard)
	.use(Popup).use(DropdownMenu).use(DropdownItem).use(Icon).use(ActionSheet);

    export default {
        name: "Cost",
        data() {
            return {
                data: {},
				newpasswordInp:'password',
                showKeyboard: true,
                write_psd: false,
                psd_val: '',
				chargeTip:'',
				charge:0,
                form: {
                    money: '',
                    password: '',
                    bank_id: 0,
                },
				eye:1,
				show: false,
				bank_name:this.$t('cash.chooseWallet'),
				actions: [],
				setPwd:false,
				submitType:1,
				type:1,
				accaddr:'',
				show_tc:false,
				tc_content:"",
				rate:1,
				mark:"$",
				actualAmount:''
            };
        },
        created() {
            this.$parent.footer('user', false);
        },
        mounted() {
            this.start();
        },
        methods: {
			showNewsPwd() {
			    this.newpasswordInp == 'password' ? this.newpasswordInp = 'text' : this.newpasswordInp = 'password'
			},
			cashall(){
				this.form.money = this.data.money;
				this.changeAmount();
			},
			doAddAddr(){
				if(this.form.bank_id==0){
					this.$router.push('/addcountUsdt')
				}
			},
			onSelect(item){
				this.chargeTip = "";
				this.actualAmount = "";
				this.form.money = "";
				this.accaddr = item.acc;
				this.show = false;
				this.bank_name = item.name;
				this.form.bank_id = item.value;
				this.charge = item.charge;
				this.type = item.type;
				this.rate = item.rate;
				this.mark = item.mark;
				if(item.charge>0){
					this.chargeTip = this.$t('cash.charge')+item.charge+"%";
				}else{
					this.chargeTip = "";
				}
				if(item.value==0){
					this.$router.push('/addcountUsdt')
				}
			},
			changeAmount(){
				this.chargeTip = "";
				var rateTip = "";
				var num = 2;
				this.form.money = parseInt(this.form.money);
					// if(this.type==1){
					// 	if(this.rate>10000){
					// 		num = 8;
					// 	}else if(this.rate>1000){
					// 		num = 6;
					// 	}else if(this.rate>10){
					// 		num = 4;
					// 	}
					// 	this.actualAmount = "≈"+(this.form.money/this.rate).toFixed(num)+this.mark;
					// 	rateTip = "≈"+(this.form.money*this.charge/100/this.rate).toFixed(num)+this.mark+"";
					// }else{
						this.actualAmount = "≈"+this.mark+(this.form.money/this.rate).toFixed(num);
						rateTip = "≈ $ "+(this.form.money*this.charge/100).toFixed(num)+" ";
					// }
				if(this.charge>0){
					this.chargeTip = this.$t('cash.charge')+""+rateTip;
					// this.chargeTip = this.$t('cash.charge')+":$"+(this.form.money*this.charge/100).toFixed(num)+rateTip;
				}
			},
            onInput(key) {
                this.psd_val = (this.psd_val + key).slice(0, 6);
                if (this.psd_val.length == 6) {
					this.write_psd = false;
					this.form.password = this.psd_val;
					if(this.submitType==1){
						this.submit();
					}else{
						this.setIniPwdSubmit();
					}
					
                }
            },
            onDelete() {
                this.psd_val = this.psd_val.slice(0, this.psd_val.length - 1);
            },
            subAll() {
                this.form.money = this.data.money;
            },
            start() {
                Fetch('/user/my_bank').then((r) => {
                    this.data = r.data;
					this.data.money = this.data.money.toFixed(2);
					this.setPwd = r.data.intPwd;
                    var bankvalue = [];
					if(r.data.bank){
						var item = r.data.bank;
						// r.data.bank.forEach(item => {
							// var length = item.account.length;
							var account = item.addr+"";
							var itemAccount = account;//.substr(length-10,length)
							var tmpi = {
								name: item.name,
								acc: itemAccount,
								value: item.id,
								charge:r.data.cash_rate,
								rate:r.data.cash_rate,
								type:1,
								mark:item.curname
							};
							bankvalue.push(tmpi);
							this.onSelect(tmpi);
						// })
						
						bankvalue.push()
						this.actions = bankvalue;
					}else{
						bankvalue.push({
							name: this.$t('cash.addWallet'),
							value: 0,
							color:"#FF0000",
						})
						this.actions = bankvalue;
					}
                });
				Fetch('/user/cash_search').then(r => {
				    var list = r.data;
					if(list && list.length>0){
						var item = list[0];
						if(item.status==2 && item.memo && item.memo.length>3){
							this.tc_content = item.memo;
							if(localStorage.getItem('tcid')!=item.id){
								localStorage.setItem('tcid',item.id);
								this.show_tc = true;
							}
						}
					}
					
				})
				
				
            },
            submit() {
				this.psd_val="";
                if (!this.form.money) {
                    this.$toast(this.$t('cash.withdrawalAmountEmpty'));
                    return false;
                }
                if(this.form.money < 0){
                    this.$toast(this.$t('cash.withdrawalAmountNotAllow'));
                    return false;
                }
				if(parseInt(this.form.money) > parseInt(this.data.money)){
                    this.$toast(this.$t('cash.withdrawalAmountHigh'));
                    return false;
                }
                // if (this.form.bank_id == 0 || this.form.bank_id == -1) {
                //     this.$toast(this.$t('cash.withdrawalAccountEmpty'));
                //     return false;
                // }
				if (!this.form.password) {
                    this.$toast(this.$t('cash.withdrawalPasswordEmpty'));
                    return false;
                }
                Fetch('/user/cost_apply', {
                    money: this.form.money,
                    bank_id: this.form.bank_id,
                    passwd: this.form.password
                }).then(() => {
                    this.$toast({
                        background: '#07c160',
                        message: this.$t('cash.success')
                    });
                    this.$router.replace('/user')
                });
            },
			setIniPwdSubmit(){
				this.psd_val="";
				Fetch('/user/setIniPwd', {
				    password: this.form.password
				}).then(() => {
					this.setPwd = false;
				});
			},
			setIniPwd(){
				this.submitType = 2;
				this.write_psd = true;
			}
        }
    };
</script>

<style lang="less" scoped>
	
	/deep/ .van-action-sheet__item {
	    text-align: left;
	}
	/deep/ .van-popup--bottom{
		border-radius:0;
		padding-bottom: 15px;
	}
	.balance{
		background: #ffffff;
		border-radius: 6px;
		padding: 20px 0px;
		text-align: center;
		margin: 10px;
		box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.1) 0px 2px 4px -2px;
		p:nth-child(1){
			font-size: 20px;
			font-weight: bold;
			margin-bottom: 15px;
		}
		p:nth-child(2){
			color: #999;
			font-weight: bold;
		}
	}

    .wrap1 {
        margin: 10px;
		box-shadow: none;
		background: none;
		.choose_bank{
			width: 100%;
			background: #FFFFFF;
			border-radius: 5px;
			padding:15px;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			margin-top: 10px;
			box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.1) 0px 2px 4px -2px;
			div:nth-child(1){
				width: 20%;
				font-size: 14px;
				font-weight: bold;
				color: #999;
			}
			div:nth-child(2){
				width: 80%;
				text-align: right;
				font-size: 12px;
				font-weight: bold;
				color: #999;
			}
		}
		.withdraw_wrap{
			width: 100%;
			background: #ffffff;
			border-radius: 6px;
			padding: 16px 20px;
			margin-top: 10px;
			box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.1) 0px 2px 4px -2px;
			input{
				height: 18px;
				width: 70%;
				line-height: 18px;
				font-size: 14px;
			}
			div{
				span:nth-child(1){
					font-size: 18px;
					margin-right: 10px;
					font-weight: bold;
				}
				span:nth-child(2){
					font-size: 14px;
					margin-left: 20px;
					font-weight: bold;
					width: 15%;
					color: #999;
					text-align: right;
				}
			}
			p:nth-child(1){
				font-size: 14px;
				font-weight: bold;
				color: #999;
				margin-bottom: 20px;
			}
			p:nth-child(3){
				color: #999;
				margin-top: 20px;
			}
		
		}
    }
	.canal_tips {
		border-top: 1px solid #ECECEC;
		display: block;
		padding: 16px;
		border-radius: 5px;
		background-color: #FFFFFF;
		line-height: 24px;
		color: #D20100cc;
		font-size: 12px;
		margin-top: 10px;
		    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.1) 0px 2px 4px -2px;
    }
    .basic_btn {
        margin: 53px auto 0 auto;
		border-radius: 5px;
    }
	
    /deep/ .van-password-input {
        margin: 50px 28px 0 28px;
    }

    /deep/ .van-hairline--left::after {
        border: 1px solid #ECECEC;
    }

    .van-password-input .van-password-input__security::after {
        border-radius: 0;
    }

    .keybord_box {
        height: 250px;
        background-color: #F0F0F0;
        margin-top: 35px;
        padding: 24px 12px 0 12px;

        .keybord {
            width: 361px;
            margin: 24px auto 0 atuo;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            text-align: center;

            .key_item {
                width: 115px;
                height: 44px;
                line-height: 44px;
                font-size: 18px;
                font-weight: bold;
                margin-bottom: 6px;
                background: rgba(255, 255, 255, 1);
                border-radius: 3px;

                &.no_bg {
                    background: none;
                }

                &.x {
                    color: #757880;
                    font-weight: bold;
                }
            }
        }
    }
	
	.ratio-info{
	    display: grid;
	    grid-template-columns: repeat(2,1fr);
	    row-gap: 14px;
	    padding: 0px 20px;
	    line-height: 1;
		dd{
		    margin: 0;
		}
		em {
		    font-style: normal;
		    font-size: 14px;
		}
	}
	.text-gray {
	    color: #ababab;
	}
	.basic_wrap{
		position: relative;
		// height: 100vh;
	}
	/deep/ .van-popup--bottom{
		position: absolute;
	}
	/deep/ .van-popup--bottom{
		padding-bottom:0;
	}
	.allbtn{
		height: 25px;
		line-height: 20px;
		padding: 2px 8px;
		border-radius: 5px;
		margin-left: 10px;
		font-size: 10px;
		box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.1) 0px 2px 4px -2px;
		background-color: #232f3e;
		color: #ffcd00;
	}
	.eye_bi {
	    width: 21px;
	    height: 25px;
	    background: url(../images/user/eye2.png) no-repeat center center;
	    background-size: 100% auto;
	
	    &.eye {
	        background: url(../images/user/eye1.png) no-repeat center center;
	        background-size: 100% auto;
	    }
	}
	.popup{
		-webkit-box-flex: 1;
		-webkit-flex: 1;
		flex: 1;
		max-height: 60vh;
		padding: 20px;
		overflow-y: auto;
		font-size: 14px;
		line-height: 20px;
	}
.finance-page {
	min-height: 100vh;
	padding-bottom: .48rem;
	box-sizing: border-box;
}

.finance-page .red_top_bg {
	height: 1.28rem;
	background: transparent;
	color: #222;
}

.finance-page .big_tit {
	top: .42rem;
	color: #222;
	font-size: .34667rem;
	font-weight: 700;
}

.finance-page .back_left {
	position: absolute;
	top: .3rem;
	left: .28rem;
	width: .48rem;
	height: .48rem;
	margin: 0;
	background: none;
}

.finance-page .back_left::after {
	color: #222;
	content: '‹';
	font-size: .64rem;
	font-weight: 300;
	line-height: .4rem;
}

.finance-page .top_right {
	top: .36rem;
	right: .36rem;
	color: #484848;
}

.finance-page .balance {
	margin: .08rem .4rem .3rem;
	padding: .36rem .4rem;
	border: .02667rem solid #ececec;
	border-radius: .26667rem;
	box-shadow: 0 .10667rem .26667rem rgba(0, 0, 0, .05);
}

.finance-page .balance p:nth-child(1) {
	margin-bottom: .12rem;
	color: #222;
	font-size: .58667rem;
	letter-spacing: -.02rem;
}

.finance-page .balance p:nth-child(2) {
	color: #717171;
	font-size: .25333rem;
	font-weight: 500;
}

.finance-page .wrap1 {
	margin: 0 .4rem;
	padding: .08rem .32rem;
	border: .02667rem solid #ececec;
	border-radius: .26667rem;
	background: #fff;
	box-shadow: 0 .10667rem .26667rem rgba(0, 0, 0, .04);
}

.finance-page .wrap1 .withdraw_wrap {
	margin: 0;
	padding: .3rem .08rem;
	border-radius: 0;
	box-shadow: none;
}

.finance-page .wrap1 .withdraw_wrap + .withdraw_wrap,
.finance-page .wrap1 .choose_bank {
	border-top: .02667rem solid #f0f0f0;
}

.finance-page .wrap1 .withdraw_wrap p:nth-child(1) {
	margin-bottom: .16rem;
	color: #484848;
	font-size: .26667rem;
	font-weight: 600;
}

.finance-page .wrap1 .withdraw_wrap input {
	width: 100%;
	height: .64rem;
	border: 0;
	border-bottom: .02667rem solid #ddd;
	border-radius: 0;
	color: #222;
	font-size: .33333rem;
}

.finance-page .wrap1 .withdraw_wrap .flex_center > span:first-child {
	width: auto;
	margin-right: .16rem;
	color: #ff385c;
	font-size: .36rem;
}

.finance-page .wrap1 .choose_bank {
	margin: 0;
	padding: .3rem .08rem;
	border-radius: 0;
	box-shadow: none;
}

.finance-page .wrap1 .choose_bank div:nth-child(1) {
	color: #484848;
	font-size: .26667rem;
	font-weight: 600;
}

.finance-page .wrap1 .choose_bank div:nth-child(2) {
	color: #717171;
	font-size: .24rem;
	font-weight: 400;
}

.finance-page .canal_tips {
	margin: 0;
	padding: .24rem .08rem .18rem;
	border: 0;
	border-top: .02667rem solid #f0f0f0;
	border-radius: 0;
	box-shadow: none;
	color: #8a8a8a;
	font-size: .22667rem;
	line-height: .36rem;
}

.finance-page > .basic_btn {
	width: calc(100% - .8rem);
	height: .96rem;
	margin: .32rem .4rem 0;
	border-radius: .2rem;
	background: #ff385c;
	box-shadow: 0 .13333rem .24rem rgba(255, 56, 92, .22);
	color: #fff;
	font-size: .32rem;
	font-weight: 600;
	line-height: .96rem;
}

.finance-page .allbtn {
	height: .52rem;
	margin-left: .16rem;
	padding: 0 .16rem;
	border: .02667rem solid #ff385c;
	border-radius: .10667rem;
	background: #fff;
	box-shadow: none;
	color: #ff385c;
	font-size: .21333rem;
	line-height: .46rem;
}

.finance-page /deep/ .van-popup--bottom {
	position: fixed;
	border-radius: .26667rem .26667rem 0 0;
}

.cash-premium {
	min-height: 100vh;
	padding: .22rem .32rem 1.96rem;
	box-sizing: border-box;
}

.cash-premium .finance-header {
	height: 1.06rem;
	margin: 0;
	border: .02667rem solid rgba(255, 255, 255, .82);
	border-radius: .24rem;
	background: rgba(255, 255, 255, .82);
	box-shadow: 0 .10667rem .26667rem rgba(39, 52, 76, .08);
	backdrop-filter: blur(.16rem);
}

.cash-premium .finance-header .big_tit {
	top: .3rem;
	color: #202b3d;
	font-size: .32rem;
	font-weight: 700;
}

.cash-premium .finance-header .back_left {
	top: .28rem;
	left: .2rem;
}

.cash-premium .finance-header .back_left::after {
	color: #202b3d;
	font-size: .58rem;
}

.cash-premium .finance-header .top_right {
	top: .3rem;
	right: .26rem;
	color: #202b3d;
}

.cash-premium .balance-card {
	position: relative;
	margin: .28rem 0 0;
	padding: .42rem .4rem;
	overflow: hidden;
	border: 0;
	border-radius: .28rem;
	background: linear-gradient(135deg, rgba(22, 38, 62, .96), rgba(45, 65, 95, .92));
	box-shadow: 0 .18667rem .34667rem rgba(22, 38, 62, .22);
	text-align: left;
}

.cash-premium .balance-card::after {
	position: absolute;
	top: -.6rem;
	right: -.34rem;
	width: 1.9rem;
	height: 1.9rem;
	border: .02667rem solid rgba(255, 255, 255, .18);
	border-radius: 50%;
	content: '';
}

.cash-premium .balance-card p:nth-child(1) {
	position: relative;
	z-index: 1;
	margin: 0;
	color: #fff;
	font-size: .58667rem;
	font-weight: 700;
	letter-spacing: -.02rem;
}

.cash-premium .balance-card p:nth-child(2) {
	position: relative;
	z-index: 1;
	margin-top: .1rem;
	color: rgba(255, 255, 255, .7);
	font-size: .24rem;
	font-weight: 500;
}

.cash-premium .withdraw-card {
	margin: .28rem 0 0;
	padding: .06rem .32rem;
	border: .02667rem solid rgba(255, 255, 255, .9);
	border-radius: .28rem;
	background: rgba(255, 255, 255, .92);
	box-shadow: 0 .10667rem .3rem rgba(39, 52, 76, .09);
	backdrop-filter: blur(.16rem);
}

.cash-premium .withdraw-card .withdraw_wrap {
	padding: .32rem .08rem;
	border: 0;
	box-shadow: none;
}

.cash-premium .withdraw-card .withdraw_wrap + .withdraw_wrap,
.cash-premium .withdraw-card .choose_bank {
	border-top: .02667rem solid #eaedf2;
}

.cash-premium .withdraw-card .withdraw_wrap p:nth-child(1) {
	margin-bottom: .18rem;
	color: #25344b;
	font-size: .26667rem;
	font-weight: 700;
}

.cash-premium .withdraw-card .withdraw_wrap input {
	height: .64rem;
	border-bottom: .02667rem solid #e3e7ed;
	color: #25344b;
	font-size: .29333rem;
}

.cash-premium .withdraw-card .amount-field .flex_center > span:first-child {
	color: #ff385c;
	font-size: .4rem;
	font-weight: 700;
}

.cash-premium .withdraw-card .pin-field > div {
	display: flex !important;
	align-items: center;
}

.cash-premium .withdraw-card .choose_bank {
	padding: .32rem .08rem;
	background: transparent;
}

.cash-premium .withdraw-card .choose_bank div:nth-child(1) {
	color: #25344b;
	font-size: .26667rem;
	font-weight: 700;
}

.cash-premium .withdraw-card .choose_bank div:nth-child(2) {
	color: #717e90;
	font-size: .24rem;
}

.cash-premium .withdraw-card .canal_tips {
	padding: .24rem .08rem;
	border-top: .02667rem solid #eaedf2;
	background: transparent;
	color: #7c8797;
	font-size: .21333rem;
	line-height: .34rem;
}

.cash-premium > .basic_btn {
	width: 100%;
	height: .96rem;
	margin: .3rem 0 0;
	border-radius: .2rem;
	background: linear-gradient(90deg, #ff385c, #e61e50);
	box-shadow: 0 .14667rem .26667rem rgba(230, 30, 80, .25);
	color: #fff;
	font-size: .32rem;
	font-weight: 700;
	line-height: .96rem;
}

.cash-premium .allbtn {
	border-color: #ff385c;
	background: #fff5f7;
	color: #ff385c;
}

/* A more legible, premium bank-withdrawal form for mobile screens. */
.cash-premium {
	padding: .2rem .32rem 1.96rem;
}

.cash-premium .finance-header {
	height: 1.33333rem;
	border-radius: .24rem;
	background: rgba(255, 255, 255, .88);
	box-shadow: 0 .10667rem .26667rem rgba(39, 52, 76, .08);
}

.cash-premium .finance-header .big_tit {
	top: 0;
	height: 1.33333rem;
	color: #202b3d;
	font-size: .4rem;
	line-height: 1.33333rem;
}

.cash-premium .finance-header .back_left {
	top: 0;
	left: 0;
	width: 1.17333rem;
	height: 1.33333rem;
}

.cash-premium .finance-header .back_left::after {
	position: absolute;
	top: .48rem;
	left: .45333rem;
	width: .26667rem;
	height: .26667rem;
	border-bottom: .05333rem solid #26364e;
	border-left: .05333rem solid #26364e;
	color: transparent;
	content: '';
	transform: rotate(45deg);
}

.cash-premium .finance-header .top_right {
	top: 0;
	right: 0;
	display: flex;
	width: 1.17333rem;
	height: 1.33333rem;
	align-items: center;
	justify-content: center;
	color: #26364e;
}

.cash-premium .balance-card {
	margin-top: .32rem;
	padding: .46rem .44rem;
	border-radius: .3rem;
	background: linear-gradient(130deg, #1c2d47, #314b70 67%, #4a617f);
	box-shadow: 0 .18667rem .4rem rgba(24, 42, 67, .24);
}

.cash-premium .balance-card p:nth-child(1) {
	font-size: .64rem;
	line-height: 1.08;
}

.cash-premium .balance-card p:nth-child(2) {
	margin-top: .14rem;
	font-size: .29333rem;
}

.cash-premium .withdraw-card {
	margin-top: .32rem;
	padding: .1rem .34rem;
	border-radius: .3rem;
	background: rgba(255, 255, 255, .96);
	box-shadow: 0 .13333rem .32rem rgba(35, 50, 73, .1);
}

.cash-premium .withdraw-card .withdraw_wrap {
	padding: .38rem .08rem;
}

.cash-premium .withdraw-card .withdraw_wrap p:nth-child(1),
.cash-premium .withdraw-card .choose_bank div:nth-child(1) {
	margin-bottom: .2rem;
	color: #2b3a51;
	font-size: .34667rem;
	font-weight: 700;
}

.cash-premium .withdraw-card .amount-field .flex_center,
.cash-premium .withdraw-card .pin-field > div {
	box-sizing: border-box;
	min-height: .96rem;
	padding: 0 .2rem;
	border: .02667rem solid #e7ebf0;
	border-radius: .16rem;
	background: #f8fafc;
}

.cash-premium .withdraw-card .amount-field .flex_center {
	display: flex;
	align-items: center;
}

.cash-premium .withdraw-card .amount-field .flex_center > span:first-child {
	margin-right: .14rem;
	color: #e31c5f;
	font-size: .42667rem;
}

.cash-premium .withdraw-card .withdraw_wrap input {
	height: .86rem;
	border: 0;
	background: transparent;
	color: #28374d;
	font-size: .34667rem;
}

.cash-premium .withdraw-card .withdraw_wrap input::placeholder {
	color: #8e98a5;
	-webkit-text-fill-color: #8e98a5;
}

.cash-premium .withdraw-card .pin-field > div {
	display: flex !important;
	align-items: center;
}

.cash-premium .withdraw-card .pin-field .eye_bi {
	flex: 0 0 .48rem;
	height: .56rem;
	margin-left: .12rem;
	background-size: .4rem auto;
}

.cash-premium .withdraw-card .choose_bank {
	min-height: 1.16rem;
	padding: 0 .08rem;
}

.cash-premium .withdraw-card .choose_bank div:nth-child(1) {
	margin: 0;
}

.cash-premium .withdraw-card .choose_bank div:nth-child(2) {
	color: #657287;
	font-size: .32rem;
}

.cash-premium .withdraw-card .canal_tips {
	padding: .26rem .08rem .28rem .22rem;
	border-left: .05333rem solid #ff385c;
	color: #6e7988;
	font-size: .29333rem;
	line-height: .42rem;
}

.cash-premium > .basic_btn {
	height: 1.06667rem;
	margin-top: .36rem;
	border-radius: .21333rem;
	background: linear-gradient(96deg, #ff4d72, #d81f62);
	box-shadow: 0 .16rem .32rem rgba(216, 31, 98, .24);
	font-size: .37333rem;
	line-height: 1.06667rem;
}

.cash-premium .allbtn {
	height: .6rem;
	padding: 0 .18rem;
	border-radius: .12rem;
	font-size: .26667rem;
	line-height: .54rem;
}

/* Match the withdrawal gateway: one calm visual system and a 12/14/16px type scale. */
.cash-premium {
	padding: 0 0 72px;
}

.cash-premium .finance-header {
	height: 50px;
	border: 0;
	border-bottom: 1px solid rgba(235, 235, 235, .9);
	border-radius: 0;
	box-shadow: none;
	backdrop-filter: blur(10px);
}

.cash-premium .finance-header .big_tit {
	top: 0;
	height: 50px;
	font-size: 16px;
	line-height: 50px;
}

.cash-premium .finance-header .back_left {
	top: 0;
	left: 0;
	width: 44px;
	height: 50px;
}

.cash-premium .finance-header .back_left::after {
	top: 18px;
	left: 17px;
	width: 11px;
	height: 11px;
	border-bottom: 2px solid #26364e;
	border-left: 2px solid #26364e;
	content: '';
	transform: rotate(45deg);
}

.cash-premium .finance-header .top_right {
	top: 0;
	right: 0;
	display: flex;
	width: 44px;
	height: 50px;
	align-items: center;
	justify-content: center;
}

.cash-premium .balance-card {
	margin: 16px 16px 12px;
	padding: 18px 20px;
	border-radius: 16px;
	background: linear-gradient(125deg, #1d304d, #355678 72%, #4a617f);
	box-shadow: 0 10px 24px rgba(25, 46, 75, .2);
}

.cash-premium .balance-card p:nth-child(1) {
	font-size: 16px;
	line-height: 1.3;
}

.cash-premium .balance-card p:nth-child(2) {
	margin-top: 4px;
	font-size: 12px;
	line-height: 1.4;
}

.cash-premium .withdraw-card {
	margin: 0 16px;
	padding: 4px 14px;
	border-radius: 16px;
	background: rgba(255, 255, 255, .97);
	box-shadow: 0 8px 22px rgba(35, 50, 73, .08);
}

.cash-premium .withdraw-card .withdraw_wrap {
	padding: 16px 2px;
}

.cash-premium .withdraw-card .withdraw_wrap p:nth-child(1),
.cash-premium .withdraw-card .choose_bank div:nth-child(1) {
	margin-bottom: 8px;
	font-size: 14px;
	line-height: 1.4;
}

.cash-premium .withdraw-card .amount-field .flex_center,
.cash-premium .withdraw-card .pin-field > div {
	min-height: 44px;
	padding: 0 10px;
	border-radius: 10px;
}

.cash-premium .withdraw-card .amount-field .flex_center > span:first-child {
	font-size: 16px;
}

.cash-premium .withdraw-card .withdraw_wrap input {
	height: 42px;
	font-size: 14px;
}

.cash-premium .withdraw-card .choose_bank {
	min-height: 54px;
	padding: 0 2px;
}

.cash-premium .withdraw-card .choose_bank div:nth-child(2) {
	font-size: 14px;
}

.cash-premium .withdraw-card .canal_tips {
	padding: 10px 2px 12px 10px;
	font-size: 12px;
	line-height: 1.5;
}

.cash-premium > .basic_btn {
	width: calc(100% - 32px);
	height: 48px;
	margin: 14px 16px 0;
	border-radius: 12px;
	font-size: 16px;
	line-height: 48px;
}

.cash-premium .allbtn {
	box-sizing: border-box;
	display: inline-flex;
	flex: 0 0 42px;
	width: 42px;
	height: 28px;
	align-items: center;
	justify-content: center;
	margin-left: 8px;
	padding: 0;
	border: 1px solid #ff8fa5;
	font-size: 12px;
	line-height: 1;
	outline: 0;
	overflow: hidden;
	white-space: nowrap;
	-webkit-appearance: none;
	appearance: none;
}

.cash-premium .amount-field input[type='number'] {
	flex: 1 1 auto;
	width: auto;
	min-width: 0;
}

.cash-premium .amount-field input[type='number']::-webkit-inner-spin-button,
.cash-premium .amount-field input[type='number']::-webkit-outer-spin-button {
	margin: 0;
	-webkit-appearance: none;
}
</style>
